<template>
	<div>
		<section :class="{'l-search__head': fromListNews}">
			<div :class="{ 'l-deal-and-shop': fromListNews, 'pt-12': true }">
				<div class="l-deal-and-shop__title d-flex pt-12 pb-12">
					<div></div>
					<div class="l-deal_view-all">
						<switch-favorite :isFavorite="isFavorite" :toggleFavorite="toggleFavorite" />
					</div>
				</div>
				<div class="c-list-deal__item" v-if="newsList.length == 0">
					ただいま掲載中の情報はありません
				</div>
				<div class="c-list-deal">
					<div class="c-list-deal__items">
						<div v-for="(news, index) in newsList" :key="news.id + index" class="c-list-deal__item--wrap"
							v-show="!isFavorite || (favoriteNewsExists(news.id) && isFavorite)">
							<div class="c-list-deal__item">
								<div v-on:click="openModalDetail(news)" class="c-list-deal__img js-keep-ratio" data-ratio="0.746">
									<img v-lazy="getImgSrc(news.image && news.image[0])" alt="" />
									<div v-if="isNew( new Date(news.discloseAt))" class="shopnew__unread">
										<span>NEW</span>
									</div>
								</div>
								<div class="c-list-deal__info">
									<div @click.prevent="shopTop(news.provider)" class="c-news__shop">
										<div v-if="news.provider && news.provider.id" class="c-news__shop--name">
											<div v-if="!readNewsExists(news.id)" class="c-info--time">
												<span class="unread"></span>
											</div>
											<span>{{ news.provider.shopName }}</span>
										</div>
										<div v-else class="c-news__shop--name">
											<span>{{ news.provider && news.provider.name }}</span>
										</div>
									</div>
									<div @click.self="openModalDetail(news)"
										class="c-list-deal__info--content c-list-deal__info--title line-clamp-hack c-list-deal__info--title--shop">
										<div class="font-bold" v-html="news.title"></div>
										<favorite-icon :isActive="favoriteNewsExists(news.id)" :toggleFavorite="() => toggleFavoriteNews(news)" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<modal :open="openModal" @close="() => {
			openModal = false;
			if (fromListNews) this.$router.push({ query: {} });
			else this.$router.go(-1);
		}">
			<news-detail :newsId="newsId" :newsProviderId="newsProviderId" :toggleFavoriteNews="(e) => toggleFavoriteNews(e)" :isActive="favoriteNewsExists" @navigateBack="() => this.navigateBack(fromListNews)"	 />
		</modal>
	</div>
</template>
<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import SwitchFavorite from "../components/SwitchFavorite.vue";
import FavoriteIcon from "../components/FavoriteIcon.vue";
import { getImgSrc } from "../utils";
import { NEW_COLLECTION_KEY } from "../config/const";
import Modal from "../components/Modal.vue";
import NewsDetail from "../views/NewsDetail.vue";
import { Tenant } from "../plugin/mixin";
import { Common } from "../common/common";
export default Vue.extend({
	name: "NewsList",
	components: {
		SwitchFavorite,
		FavoriteIcon,
		Modal,
		NewsDetail
	},
	props: {
		newsList: {
			type: Array,
			required: true
		},
		queryIdKey: {
			type: String,
			required: false,
			default: 'id'
		},
		queryProviderIdKey: {
			type: String,
			required: false,
			default: 'providerId'
		},
		fromListNews: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	mixins: [Tenant],
	data() {
		return {
			isFavorite: false,
			NEW_COLLECTION_KEY,
			openModal: false,
			newsId: "",
			newsProviderId: "",
			shopId: this.SHOP_ID || this.$store.state.shopId,
		};
	},
	updated() {
		this.$nextTick(function () {
			Common.setKeepRatio()
		})
	},
	watch: {
		'$route.query': {
			handler: function (newVal) {
				if (!newVal[this.queryIdKey]) {
					this.openModal = false
					return;
				}
				this.newsId = newVal[this.queryIdKey]
				this.newsProviderId = newVal[this.queryProviderIdKey] || this.shopId
				this.openModal = true
			},
			immediate: true
		}
	},
	methods: {
		getImgSrc,
		toggleFavorite() {
			this.isFavorite = !this.isFavorite;
		},
		openModalDetail(news) {
			const listQuery = !this.fromListNews ? {
				...this.$route.query,
				[`${this.queryIdKey}`]: news.id,
				[`${this.queryProviderIdKey}`]: news.provider && news.provider.id
			} : {
				[`${this.queryIdKey}`]: news.id,
				[`${this.queryProviderIdKey}`]: news.provider && news.provider.id
			}
			this.$router.push({ query: listQuery });
			if (!this.readNewsExists(news.id)) {
				this.addRead(news, NEW_COLLECTION_KEY, news.provider);
			}
		},
		toggleFavoriteNews(news) {
			if (this.favoriteNewsExists(news.id)) {
				this.deleteFavorite(news, NEW_COLLECTION_KEY, news.provider);
			} else {
				this.addFavorite(news, NEW_COLLECTION_KEY, news.provider);
			}
		},
	}
});
</script>
